import Cat from '@assets/general/cat404/cat_b.svg';
import DevRevBubble from '@assets/general/devRev/bubble_d.svg';
import logoForDark from '@assets/logos/Descope_CMYK_ForDarkBackground.svg';
import Apple from '@assets/logos/Social/apple_b.svg';
import Discord from '@assets/logos/Social/discord_b.svg';
import Facebook from '@assets/logos/Social/fb.svg';
import Github from '@assets/logos/Social/github_b.svg';
import Gitlab from '@assets/logos/Social/gitlab_b.svg';
import Google from '@assets/logos/Social/google.svg';
import AppleIcon from '@assets/logos/Social/icons/icon-apple-white.svg';
import DiscordIcon from '@assets/logos/Social/icons/icon-discord.svg';
import FacebookIcon from '@assets/logos/Social/icons/icon-fb.svg';
import FingerprintIcon from '@assets/logos/Social/icons/icon-fingerprint-white.svg';
import GithubIcon from '@assets/logos/Social/icons/icon-github-white.svg';
import GitlabIcon from '@assets/logos/Social/icons/icon-gitlab.svg';
import GoogleIcon from '@assets/logos/Social/icons/icon-google.svg';
import SSOIcon from '@assets/logos/Social/icons/icon-key-white.svg';
import LinkedinIcon from '@assets/logos/Social/icons/icon-linkedin.svg';
import MicrosoftIcon from '@assets/logos/Social/icons/icon-ms.svg';
import PasskeyIcon from '@assets/logos/Social/icons/icon-passkey-white.svg';
import Linkedin from '@assets/logos/Social/linkedin.svg';
import MS from '@assets/logos/Social/microsoft_b.svg';
import SendGridIconDark from '@assets/logos/connectors/send-grid-light.svg';
import SmtpIconDark from '@assets/logos/connectors/smtp-dark.svg';
import TwilioIconDark from '@assets/logos/connectors/twilio-logo-dark.svg';
import logoSymbolForDark from '@assets/logos/descope.svg';
import { grey } from '@mui/material/colors';
import { alpha } from '@mui/system';
import { ITheme } from 'types/theme';
import { createBaseTheme, descopeGradient } from './BaseTheme';
import TYPOGRAPHY from './Typography';

const DARK_THEME = createBaseTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: '#3AB8E6',
			dark: '#01579B',
			light: '#03A9F4'
		},
		secondary: {
			main: '#9B78EF',
			dark: '#683AE6',
			light: '#B9A0F3'
		},
		warning: {
			main: '#FFA726',
			dark: '#F57C00',
			light: '#FFB74D'
		},
		info: {
			main: '#29B6F6',
			dark: '#0288D1',
			light: '#4FC3F7'
		},
		success: {
			main: '#66BB6A',
			light: '#D2EBD3',
			dark: '#66BB6A'
		},
		brand: {
			descopeGradient,
			first: '#0082b5',
			second: '#00ffff',
			third: '#6ff12d'
		},
		border: {
			main: '#3C3C3C'
		},
		action: {
			disabled: 'rgba(255, 255, 255, 0.5)'
		},
		card: {
			main: '#1a1a1a'
		},
		wizard: {
			card: {
				main: '#121212',
				light: '#102029',
				secondary: '#27123D',
				disabled: '#252525'
			}
		},
		layout: {
			background: 'grey.900'
		},
		multiline: {
			// using 'grey.800' does not work
			background: grey[800]
		}
	},
	components: {
		MuiListItemButton: {
			styleOverrides: {
				root: ({ theme }) => ({
					'&.Mui-selected': {
						backgroundColor: alpha(theme.palette.primary.dark, 0.3)
					}
				})
			}
		},
		MuiAlert: {
			defaultProps: {
				variant: 'outlined'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					backgroundColor: alpha(theme.palette.background.default, 0.8)
				})
			}
		},
		MuiIconButton: {
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.grey[700]
				})
			}
		}
	},
	...TYPOGRAPHY
});

const getDarkTheme = (): ITheme => ({
	...DARK_THEME,
	assets: {
		socials: {
			Apple: () => Apple,
			Google: () => Google,
			Github: () => Github,
			Facebook: () => Facebook,
			Microsoft: () => MS,
			Discord: () => Discord,
			Linkedin: () => Linkedin,
			Gitlab: () => Gitlab,
			icons: {
				AppleIcon: () => AppleIcon,
				GithubIcon: () => GithubIcon,
				FacebookIcon: () => FacebookIcon,
				FingerprintIcon: () => FingerprintIcon,
				PasskeyIcon: () => PasskeyIcon,
				GoogleIcon: () => GoogleIcon,
				SSOIcon: () => SSOIcon,
				MicrosoftIcon: () => MicrosoftIcon,
				LinkedinIcon: () => LinkedinIcon,
				GitlabIcon: () => GitlabIcon,
				DiscordIcon: () => DiscordIcon
			}
		},
		connectors: {
			SmtpIcon: () => SmtpIconDark,
			SendGridIcon: () => SendGridIconDark,
			TwilioIcon: () => TwilioIconDark
		},

		descope: {
			DescopeLogo: () => logoForDark,
			DescopeLogoSymbol: () => logoSymbolForDark
		},
		general: {
			Cat: () => Cat,
			DevRevBubble: () => DevRevBubble
		}
	}
});

export default getDarkTheme;
